import React, { useEffect, useRef } from "react"
import types from "prop-types"
import clsx from "clsx"
import { FormsyTextInput } from "shared/inputs"

const WhitelistedUserEmailDescFormFields = ({ className = "" }) => {
  const inputRef = useRef()

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  return (
    <div className={clsx(className)}>
      <FormsyTextInput
        className="bordered-base-input text-sm bg-white base-input"
        name="description"
        inputRef={inputRef}
        validations={{ isNotBlankString: true }}
        value=""
      />
    </div>
  )
}

WhitelistedUserEmailDescFormFields.propTypes = {
  className: types.string,
}

export default WhitelistedUserEmailDescFormFields
